
<c-contract-editor
    :title     = "$t('contract.dls.fulltitle')"
    :unit-data = "unitData"
    :terminate = "true"
    @store     = "onStore"
    @edit      = "onEdit"
    @start     = "onStart"
    @end       = "onEnde"
>
    <template v-slot:additional>
        <v-row class="no-frame">
            <v-col class="no-frame pr-2 col-6">
                <f-currency-field-rw
                    class         = "money"
                    :label        = "$t('contract.dls.netamount')"
                    :readonly     = "readonly"
                    v-model       = "unitData.netamount"
                    :hide-details = "true"
                />
            </v-col>
            <v-col class="no-frame pl-2 col-6">
                <f-currency-field-rw
                    class         = "money"
                    :label        = "$t('contract.dls.grossamount')"
                    :readonly     = "readonly"
                    v-model       = "unitData.grossamount"
                    :hide-details = "true"
                />
            </v-col>
        </v-row>
    </template>
</c-contract-editor>
